import { useEffect, useMemo, useRef, useState } from "react";
import { useAppDispatch } from "../redux/store";
import { Dialog, DialogContent } from "@mui/material";

import {
  fetchAllTaglists,
  assignTagToPost,
  setTagmePost,
} from "../redux/lounges/slice";

import { components } from "react-select";
import { default as ReactSelect } from "react-select";

type TagMePropsType = {
  isOpen: any;
  isClosed: any;
  TagDatas: any;
  chatId: any;
  Page: any;
};

type optionType = {
  value: any;
  label: string;
};

const RECENT_TAGS_STORAGE_KEY = "mw_recent_tag_me_tags";
const MAX_RECENT_TAGS = 8;

const readRecentTags = (): optionType[] => {
  try {
    const parsed = JSON.parse(
      localStorage.getItem(RECENT_TAGS_STORAGE_KEY) || "[]"
    );
    return Array.isArray(parsed)
      ? parsed
          .filter((tag) => tag?.value && tag?.label)
          .map((tag) => ({ value: tag.value, label: tag.label }))
      : [];
  } catch {
    return [];
  }
};

const saveRecentTags = (selectedTags: optionType[]) => {
  const previousTags = readRecentTags();
  const mergedTags = [...selectedTags, ...previousTags].reduce<optionType[]>(
    (acc, tag) => {
      if (!acc.some((item) => String(item.value) === String(tag.value))) {
        acc.push({ value: tag.value, label: tag.label });
      }
      return acc;
    },
    []
  );

  localStorage.setItem(
    RECENT_TAGS_STORAGE_KEY,
    JSON.stringify(mergedTags.slice(0, MAX_RECENT_TAGS))
  );
};

const orderTagOptions = (
  allTags: optionType[],
  selectedTags: optionType[],
  recentTags: optionType[]
) => {
  const selectedIds = new Set(selectedTags.map((tag) => String(tag.value)));
  const recentIds = recentTags.map((tag) => String(tag.value));

  return [...allTags].sort((first, second) => {
    const firstRecentIndex = recentIds.indexOf(String(first.value));
    const secondRecentIndex = recentIds.indexOf(String(second.value));

    if (firstRecentIndex !== -1 || secondRecentIndex !== -1) {
      if (firstRecentIndex === -1) return 1;
      if (secondRecentIndex === -1) return -1;
      return firstRecentIndex - secondRecentIndex;
    }

    const firstSelected = selectedIds.has(String(first.value));
    const secondSelected = selectedIds.has(String(second.value));
    if (firstSelected !== secondSelected) {
      return firstSelected ? -1 : 1;
    }

    return first.label.localeCompare(second.label);
  });
};

const Option = (props: any) => {
  return (
    <div className="mw-tag-me-option">
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

export const TagMe: React.FC<TagMePropsType> = ({
  isOpen,
  isClosed,
  TagDatas,
  chatId,
  Page,
}) => {
  const dispatch = useAppDispatch();
  const selectRef = useRef<any>(null);

  const onSubmit = () => {
    const selectedTags = optionSelected || [];
    const data = {
      chatId: chatId,
      checkedId: selectedTags.map((val: any) => val.value),
    };
    const tagData = allTagList.filter(
      (item: any) =>
        data?.checkedId.filter((check) => check === item?.value).length
    );
    const formattedTagData = tagData.map((item: any) => {
      return {
        tags_id: item?.value,
        chat_id: chatId,
        gettagged: [
          {
            id: item?.value,
            tags_name: item?.label,
          },
        ],
      };
    });

    dispatch(setTagmePost({ chatId, tagData: formattedTagData }));
    saveRecentTags(selectedTags);
    isClosed();

    dispatch<any>(assignTagToPost(data)).then((res: any) => {
      if (res?.error) {
        console.error("Tag Me failed", res.error);
      }
    });
  };

  const [allTagList, setAllTagList] = useState<optionType[]>([]);
  const [recentTags, setRecentTags] = useState<optionType[]>([]);
  const [optionSelected, setOptionSelected] = useState<Array<optionType>>([]);

  useEffect(() => {
    let LoungeId: any = chatId;
    let tagData: any = null;
    let preSelectList: any = [];

    dispatch(fetchAllTaglists({ tagData, LoungeId })).then((res: any) => {
      const transformedOptions = (res.payload || []).map((option: any) => {
        if (isOpen && option.gettagdata?.length != 0) {
          preSelectList = [
            ...preSelectList,
            { value: option["id"], label: option["tags_name"] },
          ];
        }
        return {
          value: option["id"],
          label: option["tags_name"],
        };
      });
      setOptionSelected(preSelectList);
      setAllTagList(transformedOptions);
    });
  }, [chatId, dispatch, isOpen]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    setRecentTags(readRecentTags());
    window.setTimeout(() => selectRef.current?.focus?.(), 80);
  }, [isOpen]);

  const orderedTagList = useMemo(
    () => orderTagOptions(allTagList, optionSelected, recentTags),
    [allTagList, optionSelected, recentTags]
  );

  const visibleRecentTags = useMemo(() => {
    const tagIds = new Set(allTagList.map((tag) => String(tag.value)));
    return recentTags.filter((tag) => tagIds.has(String(tag.value)));
  }, [allTagList, recentTags]);

  const toggleRecentTag = (tag: optionType) => {
    const isSelected = optionSelected.some(
      (selected) => String(selected.value) === String(tag.value)
    );

    setOptionSelected(
      isSelected
        ? optionSelected.filter(
            (selected) => String(selected.value) !== String(tag.value)
          )
        : [...optionSelected, tag]
    );

    window.setTimeout(() => selectRef.current?.focus?.(), 0);
  };

  const selectedCount = optionSelected.length;

  return (
    <div>
      {isOpen == true && (
        <>
          <div className="containerDialog mw-tag-me-dialog-wrap">
            <Dialog
              PaperProps={{
                className: "mw-tag-me-paper",
              }}
              className="tagDialog"
              open={isOpen}
              onClose={isClosed}
            >
              <DialogContent className="mw-tag-me-content">
                <div className="mw-tag-me-header">
                  <div>
                    <p className="mw-tag-me-eyebrow">Tag Post</p>
                    <h2>Choose Lounge Tags</h2>
                  </div>
                  <button
                    type="button"
                    className="mw-tag-me-close"
                    aria-label="Close Tag Me"
                    onClick={isClosed}
                  >
                    x
                  </button>
                </div>

                {visibleRecentTags.length > 0 && (
                  <div className="mw-tag-me-recent" aria-label="Recently used tags">
                    <span>Recent</span>
                    <div>
                      {visibleRecentTags.map((tag) => {
                        const isSelected = optionSelected.some(
                          (selected) => String(selected.value) === String(tag.value)
                        );

                        return (
                          <button
                            key={`recent-${tag.value}`}
                            type="button"
                            className={isSelected ? "is-selected" : ""}
                            onClick={() => toggleRecentTag(tag)}
                          >
                            {tag.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}

                <span
                  className="mw-tag-me-select-wrap"
                >
                  <ReactSelect
                    ref={selectRef}
                    inputId="mw-tag-me-search"
                    aria-label="Search tags"
                    classNamePrefix="mw-tag-select"
                    options={orderedTagList}
                    isMulti
                    autoFocus
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                      Option,
                    }}
                    menuIsOpen={true}
                    onChange={(selected: any) =>
                      setOptionSelected(selected || [])
                    }
                    value={optionSelected}
                    placeholder="Search tags..."
                    noOptionsMessage={() => "No matching tags"}
                    maxMenuHeight={330}
                  />
                </span>

                <div className="mw-tag-me-footer">
                  <button
                    type="button"
                    className="mw-tag-me-submit"
                    onClick={onSubmit}
                  >
                    Save {selectedCount > 0 ? `${selectedCount} ` : ""}Tag
                    {selectedCount === 1 ? "" : "s"}
                  </button>
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </>
      )}
    </div>
  );
};

export default TagMe;
